import React, { ReactNode } from 'react';
import { useDraggable } from '@dnd-kit/core';
import {CSS} from '@dnd-kit/utilities';


interface DraggableProps {
  id: string;          // 确保 id 为字符串类型
  children: ReactNode; // 明确 props 中 children 的类型
}

export function Draggable({ id, children }: DraggableProps) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id, // 使用 props.id
  });

  const style = transform ? {
    transform: CSS.Translate.toString(transform),

    // transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
  } : undefined;

  return (
    <div className='draggable' ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {children}
    </div>
  );
}
